import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header align-items-center border-0 mt-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder text-dark" }, "Latest Products"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Gifts and more")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-3" }
const _hoisted_7 = { class: "symbol symbol-60px symbol-2by3 me-4" }
const _hoisted_8 = { class: "\n              d-flex\n              flex-row-fluid\n              align-items-center\n              flex-wrap\n              my-lg-0\n              me-2\n            " }
const _hoisted_9 = { class: "flex-grow-1 my-lg-0 my-2 me-2" }
const _hoisted_10 = {
  href: "#",
  class: "text-gray-800 fw-bolder text-hover-primary fs-6"
}
const _hoisted_11 = { class: "text-muted fw-bold d-block pt-1" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "me-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-star-half-alt me-1 text-warning fs-5" }, null, -1)
const _hoisted_15 = { class: "text-gray-800 fw-bolder" }
const _hoisted_16 = {
  href: "#",
  class: "btn btn-icon btn-light btn-sm border-0"
}
const _hoisted_17 = { class: "svg-icon-2 svg-icon-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown3)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: [{ 'mb-7': _ctx.list.length - 1 !== index }, "d-flex align-items-sm-center"]
        }, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", {
              class: "symbol-label",
              style: `background-image: url(${item.image})`
            }, null, 4)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("a", _hoisted_10, _toDisplayString(item.title), 1),
              _createVNode("span", _hoisted_11, _toDisplayString(item.desc), 1)
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("span", _hoisted_15, _toDisplayString(item.rate), 1)
              ]),
              _createVNode("a", _hoisted_16, [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                ])
              ])
            ])
          ])
        ], 2))
      }), 128))
    ])
  ], 2))
}